var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDiscountCard = function SvgDiscountCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 90 90",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#DiscountCard_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.156,
    cy: 45,
    r: 37,
    fill: "#DDE0F9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.156,
    cy: 45,
    r: 43,
    stroke: "#DDE0F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.06 55.12v-1.935c0-1.47.31-2.82.932-4.05a7.386 7.386 0 0 1 2.741-2.974c1.207-.753 2.676-1.129 4.408-1.129 1.756 0 3.231.37 4.425 1.11a7.103 7.103 0 0 1 2.724 2.975c.621 1.23.932 2.586.932 4.068v1.935c0 1.469-.31 2.825-.932 4.067-.621 1.23-1.535 2.216-2.741 2.956-1.207.753-2.676 1.13-4.408 1.13-1.756 0-3.231-.377-4.426-1.13a7.288 7.288 0 0 1-2.723-2.956c-.621-1.242-.932-2.598-.932-4.067Zm5.214-1.935v1.935c0 .848.203 1.648.61 2.4.417.753 1.17 1.13 2.257 1.13 1.087 0 1.827-.37 2.222-1.111a4.95 4.95 0 0 0 .609-2.42v-1.934c0-.872-.191-1.685-.574-2.437-.382-.753-1.134-1.13-2.257-1.13-1.075 0-1.822.377-2.24 1.13a4.938 4.938 0 0 0-.627 2.437ZM27.229 34.12v-1.935c0-1.481.316-2.837.95-4.067a7.386 7.386 0 0 1 2.74-2.974c1.207-.741 2.664-1.111 4.372-1.111 1.768 0 3.25.37 4.444 1.11a7.26 7.26 0 0 1 2.724 2.975c.62 1.23.931 2.586.931 4.067v1.935c0 1.481-.316 2.837-.95 4.068-.62 1.23-1.534 2.215-2.74 2.956-1.195.729-2.665 1.093-4.409 1.093-1.743 0-3.219-.37-4.425-1.111-1.195-.752-2.102-1.738-2.724-2.956-.609-1.23-.913-2.58-.913-4.05Zm5.25-1.935v1.935c0 .872.203 1.678.609 2.42.418.74 1.152 1.11 2.203 1.11 1.1 0 1.846-.37 2.24-1.11a4.95 4.95 0 0 0 .61-2.42v-1.935c0-.872-.192-1.684-.574-2.437-.382-.752-1.14-1.129-2.276-1.129-1.063 0-1.797.383-2.203 1.147a5.085 5.085 0 0 0-.61 2.42ZM29.593 62l25.228-36.695h4.694L34.288 62h-4.694Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "DiscountCard_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h90v90H0z"
  })))));
};
export default SvgDiscountCard;